import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const wrench: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M2.844-.14A.5.5 0 0 0 3-.5a.46.46 0 0 0-.156-.344A.46.46 0 0 0 2.5-1a.5.5 0 0 0-.36.156A.47.47 0 0 0 2-.5q0 .206.14.36.154.14.36.14.201 0 .344-.14M8.03-3.782 2.703 1.547A.94.94 0 0 1 2 1.844a.96.96 0 0 1-.703-.297L.469.703A.92.92 0 0 1 .172 0q0-.421.297-.719L5.78-6.03q.31.767.89 1.36.593.58 1.36.89m4.953-3.406q0 .314-.171.828-.376 1.047-1.297 1.703A3.36 3.36 0 0 1 9.5-4Q8.061-4 7.031-5.031C6.344-5.72 6-6.54 6-7.5q0-1.452 1.031-2.469C7.72-10.656 8.54-11 9.5-11q.45.001.953.125c.332.086.613.203.844.36q.124.093.125.234-.001.128-.125.203L9-8.75V-7l1.516.828q.03-.012.609-.375.575-.356 1.063-.625.48-.28.546-.281.123 0 .188.078.06.082.062.188m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-0.172 11)"
    />
  ),
  svgProps: {
    height: "12.844",
    width: "12.813",
  }
};
